var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
import { Account, FinancialPeriod } from 'models';
import { plainToInstance } from 'class-transformer';
var Balance = /** @class */ (function (_super) {
    __extends(Balance, _super);
    function Balance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Balance.prototype.getId = function () {
        return Number(this.id);
    };
    Balance.prototype.getAccount = function () {
        return plainToInstance(Account, this.account);
    };
    Balance.prototype.getAccountId = function () {
        return Number(this.account_id);
    };
    Balance.prototype.getPartner = function () {
        return this.partner;
    };
    Balance.prototype.getFinancialPeriod = function () {
        return plainToInstance(FinancialPeriod, this.financial_period);
    };
    Balance.prototype.getFinancialPeriodId = function () {
        return Number(this.financial_period_id);
    };
    Balance.prototype.getAmount = function () {
        return Number(this.amount);
    };
    Balance.prototype.getOpeningAmount = function () {
        return Number(this.opening_amount);
    };
    Balance.prototype.getEndingAmount = function () {
        return Number(this.ending_amount);
    };
    Balance.prototype.getPartnerName = function () {
        return this.partner_name;
    };
    return Balance;
}(Model));
export default Balance;
